import {BaseLinkModelSettings} from "./base-link-model-settings";
import {DEFAULT_CULTURE_NAME} from "../../../core/app/consts";
import {BaseUrlModel} from "./base-url-model";

export class LanguageLinkModel extends BaseUrlModel {
  constructor(cultureName, navigationManager) {
    const settings: BaseLinkModelSettings = new BaseLinkModelSettings(false, true);

    const currentLang: String = navigationManager.currentLinkModel?.cultureName;
    const isDefaultCurrentLang: Boolean = currentLang === DEFAULT_CULTURE_NAME;
    const isDefaultTargetLang: Boolean = cultureName === DEFAULT_CULTURE_NAME;

    const isHomePage = navigationManager.history.currentPath === (isDefaultCurrentLang ? '/' : `/${currentLang}`);
    const from: String = isDefaultTargetLang ? `/${currentLang}` : (isDefaultCurrentLang ? (isHomePage ? "/" : '') : currentLang);
    const to: String = isDefaultTargetLang ? (isHomePage ? "/" : '') : (isDefaultCurrentLang ? `/${cultureName}` : cultureName);

    const url: String = navigationManager.history.currentPath.replace?.(from, to);

    super(url, true, settings);
  }
}
